import type { ProvidersOutcome } from './queries';

export function providerStatusPresentation(providers: ProvidersOutcome) {
  const failed = providers.failed ?? [];
  const timedOut = providers.timedOut ?? [];
  const skipped = providers.skipped ?? [];
  const truncated = (providers.truncated ?? []).map((entry) => ({
    ...entry,
    totalLabel: entry.total ?? '?',
  }));
  const degraded = providers.degraded ?? [];
  const responded = providers.responded ?? [];
  const hasProblems =
    failed.length > 0 ||
    timedOut.length > 0 ||
    skipped.length > 0 ||
    degraded.length > 0;

  return {
    failed,
    timedOut,
    skipped,
    truncated,
    degraded,
    responded,
    hasProblems,
    isEmpty: !hasProblems && responded.length === 0,
  };
}
